import { autoCapitalize } from '@/utils/autoCapitalize'
import { AttendanceListTypes } from './AttendanceList.types'

class AttendanceListMapper {
  toDomain(persistenceData: AttendanceListTypes) {
    return {
      attendanceId: persistenceData?.idAtendimento,
      date: persistenceData?.data || '-',
      hour: persistenceData?.hora || '-',
      healthProfessional:
        autoCapitalize(persistenceData?.profissionalSaude) || '-',
      specialty: autoCapitalize(persistenceData?.especialidade) || '-',
      status: autoCapitalize(persistenceData?.status) || '-',
      outcome: autoCapitalize(persistenceData?.desfecho) || '-',
      paymentStatus: autoCapitalize(persistenceData?.situacaoPagamento) || '-',
      confirmedAppointment: persistenceData?.consultaConfirmada ? 'Sim' : 'Não',
      patientId: persistenceData?.idPaciente || '-',
      professionalId: persistenceData?.idProfissional || '-',
      attendanceToken: persistenceData?.tokenAtendimento,
      pvId: persistenceData?.codigoConvenioPV,
      unifiedClinic: persistenceData?.atendimentoPsicologiaClinicaUnificada,
    }
  }
}

export default new AttendanceListMapper()
